import { render, staticRenderFns } from "./faqcategorydetails.vue?vue&type=template&id=a7b0ecfe&scoped=true"
import script from "./faqcategorydetails.vue?vue&type=script&lang=js"
export * from "./faqcategorydetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7b0ecfe",
  null
  
)

export default component.exports